module.exports = __webpack_public_path__ + "img/plan_habitats.5455d180.jpg";